import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';

import { DatatableComponent } from 'src/app/shared/components/datatable/datatable.component';
import { newmetadate, style } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { FormModule } from 'src/app/shared/modulos/form.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { UtilService } from 'src/app/services/util.service';
import { DialogModule } from 'primeng/dialog';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { I_InitDatosEmision } from '../../../../orden-venta-operaciones/domain/interfaces/ov-datos-de-emision.interface';
import { D_getAuditContenedoresRequest, D_getContenedoresOvRequest, getDatosByMblOperacionesRequest } from '../../../domain/request/orden-venta-operaciones-request';
import { BuscarPorEntidad_Request } from 'src/app/comercial/orden-venta/domain/request/comercial-orden-venta-request';
import { FUNC_ENTIDAD } from 'src/app/shared/constantes/constantes';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from 'primeng/api';
import { OperacionRepository } from 'src/app/repositorio/operacion.repository';

@Component({
  selector: 'app-ov-datos-de-emision',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FloatLabelModule,
    FormModule,
    SharedModule,
    DialogModule,
  ],
  templateUrl: './ov-datos-de-emision.component.html',
})
export class OvDatosDeEmisionComponent implements OnInit {
  private maestrosSubject = new BehaviorSubject<any>(null);
  maestrosParaEmision$ = this.maestrosSubject.asObservable();
  @Input() btns_habilitados: boolean = true;
  @Input() bloqueoBtns: boolean = false;
  @Input() customButtons: any[] = [];
  @Input({ required: true }) oRow!: I_InitDatosEmision;
  solo_aereo: boolean = false;
  from_operaciones: boolean = false;

  @ViewChild('dtContenedores') dtContenedores!: DatatableComponent;

  listaShippers: any[] = [];
  listaConsignee: any[] = [];
  listaNotify: any[] = [];

  group_emision: FormGroup;
  group_master: FormGroup;
  dt_contenedores: any[] = [];
  mt_contenedores: newmetadate[] = [];
  dt_auditoriaContenedores: any[] = [];
  mt_auditoriaContenedores: newmetadate[] = [
    { title: 'OPERACION', field: 'operacion', filterType: 'text', inputType: 'text' },
    { title: 'DIRECCION IP', field: 'direccion_ip', filterType: 'text', inputType: 'text' },
    { title: 'NOMBRE MAQUINA', field: 'nombre_maquina', filterType: 'text', inputType: 'text' },
    { title: 'NOMBRE APLICACION', field: 'nombre_aplicacion', filterType: 'text', inputType: 'text' },
    { title: 'USUARIO SQL', field: 'usuario_sql', filterType: 'text', inputType: 'text' },
    { title: 'USUARIO APLICACION', field: 'usuario_aplicacion', filterType: 'text', inputType: 'text' },
    { title: 'FECHA MODIFICACION', field: 'fecha_modificacion', filterType: 'date', inputType: 'text' },
    { title: 'CODIGO OV', field: 'codigo_ov', filterType: 'numeric', inputType: 'int' },
    { title: 'TIPO OV', field: 'tipo_ov', filterType: 'numeric', inputType: 'int' },
    { title: 'CODIGO MBL', field: 'codigo_mbl', filterType: 'numeric', inputType: 'int' },
    { title: 'COD PAQUETE', field: 'cod_paquete', filterType: 'numeric', inputType: 'int' },
    { title: 'PESO BRUTO', field: 'peso_bruto', filterType: 'numeric', inputType: 'decimal' },
    { title: 'VOLUMEN', field: 'volumen', filterType: 'numeric', inputType: 'decimal' },
    { title: 'CANTIDAD BULTOS', field: 'cantidad_bultos', filterType: 'numeric', inputType: 'decimal' },
    { title: 'PRECINTO', field: 'precinto', filterType: 'text', inputType: 'text' },
    { title: 'DESCRIPCION', field: 'descripcion', filterType: 'text', inputType: 'text', maxWidth: '400px' },
    { title: 'MARCAS NUMERO', field: 'marcas_numero', filterType: 'text', inputType: 'text', maxWidth: '400px' },
    { title: 'IMO', field: 'imo', filterType: 'text', inputType: 'text' },
    { title: 'COD IMO', field: 'cod_imo', filterType: 'text', inputType: 'text' },
    { title: 'ES IMO', field: 'es_imo', filterType: 'text', inputType: 'checkboxEditInput', readonly: true },
    { title: 'IMO UN', field: 'imo_un', filterType: 'text', inputType: 'text' },
    { title: 'NRO CONTRACT', field: 'nro_contract', filterType: 'text', inputType: 'text' },
    { title: 'PARTE CONTENEDOR', field: 'parte_contenedor', filterType: 'text', inputType: 'checkboxEditInput', readonly: true },
    { title: 'NRO CONTENEDOR', field: 'nro_contenedor', filterType: 'text', inputType: 'text' },
    { title: 'ITEM', field: 'item', filterType: 'numeric', inputType: 'int' },
    { title: 'COMODITY', field: 'comodity', filterType: 'text', inputType: 'text' },
    { title: 'COD COMODITY', field: 'cod_comodity', filterType: 'text', inputType: 'text' },
    { title: 'TIPO PAQUETE', field: 'tipo_paquete', filterType: 'text', inputType: 'text' },
    { title: 'COD TIPO PAQUETE', field: 'cod_tipo_paquete', filterType: 'text', inputType: 'text' },
    { title: 'USUARIO CREA', field: 'usuario_crea', filterType: 'text', inputType: 'text' },
    { title: 'FEC CREA', field: 'fec_crea', filterType: 'date', inputType: 'text' },
    { title: 'USUARIO MODIFICA', field: 'usuario_modifica', filterType: 'text', inputType: 'text' },
    { title: 'FEC MODIFICA', field: 'fec_modifica', filterType: 'date', inputType: 'text' },
  ];

  custombContenedores = [
    { icon: 'pi pi-search', function: () => this.manejoPoupAuditoriaDatosEmision('A'), toolTip: 'Auditoria Detalle de Cotenedores' },
  ];
  custombAuditoriaContenedores = [
    { icon: 'pi pi-file-excel', function: () => this.exportarExcelAudiContenedores(), toolTip: 'Exportar Excel' },
  ];

  private _listados: any;
  @Input() set listados(value: any) {
    if (value) {
      this._listados = value;
      this.procesarListados();
    }
  }
  get listados(): any {
    return this._listados;
  }

  estilos: style = {
    header: { align: 'left', justify: 'center', size: '10px' },
    body: { size: '9px' }
  };

  constructor(
    private readonly util: UtilService
    , private readonly ordenventaService: ComercialRepository
    , private messageService: MessageService
    , private readonly opeRepository: OperacionRepository
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.initMetadata();
    if (this.oRow) {
      this.cargarDatosIniciales();
    }
  }

  private initForm() {
    this.group_emision = new FormGroup({
      shipper: new FormControl(null),
      notify: new FormControl(null),
      consignee: new FormControl(null),
      applyto: new FormControl(null),
      place_receipt: new FormControl(null),
      place_delivery: new FormControl(null),
    });

    this.group_master = new FormGroup({
      shipper: new FormControl(null),
      notify: new FormControl(null),
      consignee: new FormControl(null),
      desc_shipper: new FormControl(null),
      desc_notify: new FormControl(null),
      desc_consignee: new FormControl(null),
    });
  }

  private initMetadata() {
    this.mt_contenedores = [
      { title: 'NÚMERO DE CONTENEDOR', field: 'cntr_numero', filterType: 'text', inputType: 'text', verColumna: (row) => this.solo_aereo == false && this.from_operaciones, },
      { title: 'PRECINTO', field: 'dhbl_precinto', filterType: 'text', inputType: 'text', verColumna: (row) => this.solo_aereo == false && this.from_operaciones, },
      { title: 'TIPO CONTENEDOR', field: 'tipo_cntr', filterType: 'text', inputType: 'autocomplete', dropdown: this.listados.paquetes, },
      { title: 'DESCRIPCIÓN DE LA CARGA', field: 'dhbl_descproducto', filterType: 'text', inputType: 'viewobservaciones', maxWidth: '400px' },
      { title: 'MARCAS Y NÚMEROS', field: 'dhbl_marcasnumeros', filterType: 'text', inputType: 'viewobservaciones', maxWidth: '400px' },
      { title: 'CANTIDAD DE BULTOS', field: 'dhbl_cantbultos', filterType: 'numeric', inputType: 'decimal' },
      { title: 'PESO (Kg.)', field: 'dhbl_pesobruto', filterType: 'numeric', inputType: 'decimal' },
      { title: 'VOLUMEN (m³)', field: 'dhbl_volumen', filterType: 'numeric', inputType: 'decimal' },
      { title: 'COMODITY', field: 'comodity', filterType: 'text', inputType: 'autocomplete', dropdown: this.listados.comodities, widthInput: '300px' },
      { title: 'TIPO BULTO', field: 'tipo_bulto', filterType: 'text', inputType: 'autocomplete', dropdown: this.listados.bultos, widthInput: '300px' },
      { title: 'ES IMO', field: 'dhbl_esimo', filterType: 'text', inputType: 'checkboxEditInput', readonly: false },
      { title: 'CLASE IMO', field: 'clase_imo', filterType: 'text', inputType: 'autocomplete', dropdown: this.listados.claseimo, widthInput: '300px' },
      { title: 'IMO UN', field: 'dhbl_imoun', filterType: 'text', inputType: 'text' },
      { title: 'CONTRACT NRO', field: 'dhbl_contractnro', filterType: 'text', inputType: 'text' },
      { title: 'RATE/CHARGE', field: 'dhbl_ratecharge', filterType: 'text', inputType: 'decimal', required: true, verColumna: (row) => this.solo_aereo && this.from_operaciones, },
      { title: 'ES PARTE CONTENEDOR', field: 'dhbl_pp', filterType: 'text', inputType: 'checkboxEditInput', readonly: false, verColumna: (row) => this.solo_aereo == false && this.from_operaciones, },
    ];
  }

  public cargarDatosIniciales() {

    this.dt_contenedores = [];
    this.group_emision.reset();
    this.group_master.reset();

    this.solo_aereo = this.oRow.solo_aereo;
    this.from_operaciones = this.oRow.from_operaciones;

    this.group_emision.patchValue({
      shipper: this.oRow.ddov_descshipper,
      notify: this.oRow.ddov_descnotify,
      consignee: this.oRow.ddov_descconsignee,
      applyto: this.oRow.ddov_descapplyto,
      place_receipt: this.oRow.doov_placereceipt,
      place_delivery: this.oRow.doov_placedelivery,
    });

    this.group_master.patchValue({
      consignee: this.oRow.ddov_mblconsignee,
      desc_consignee: this.oRow.ddov_mbldescconsignee,
      shipper: this.oRow.ddov_mblshipper,
      desc_shipper: this.oRow.ddov_mbldescshipper,
      notify: this.oRow.ddov_mblnotify,
      desc_notify: this.oRow.ddov_mbldescnotify
    });

    if (this.oRow.listadoContenedores && this.oRow.listadoContenedores.length > 0) {
      const lista_conts = this.oRow.listadoContenedores;
      lista_conts.forEach(item => {
        item['ESTADO_OBJ'] = "NA";
      });
      this.dt_contenedores = [...lista_conts];
    }

    this.onChangeConsignee(this.oRow.cod_consignee, true);
    this.onChangeNotify(this.oRow.cod_notify, true);
    this.onChangeShipper(this.oRow.cod_shipper, true);
    this.onChangeConsigneeMbl(true);
    this.onChangeNotifyMbl(true);
    this.onChangeShipperMbl(true);
    this.onChangeMbl(this.oRow.mbl, true);

  }

  private procesarListados() {
    if (this.mt_contenedores && this.mt_contenedores.length > 0) {

      this.mt_contenedores.forEach(col => {
        if (col.field === 'tipo_cntr') col.dropdown = this.listados.paquetes;
        if (col.field === 'comodity') col.dropdown = this.listados.comodities;
        if (col.field === 'tipo_bulto') col.dropdown = this.listados.bultos;
        if (col.field === 'clase_imo') col.dropdown = this.listados.claseimo;
      });

      this.mt_contenedores = [...this.mt_contenedores];

      this.listaShippers = (this.listados.listaShippers || []).map(item => ({
        ...item,
        codigo: Number(item.codigo)
      }));

      this.listaConsignee = (this.listados.listaConsignee || []).map(item => ({
        ...item,
        codigo: Number(item.codigo)
      }));

      this.listaNotify = (this.listados.listaNotify || []).map(item => ({
        ...item,
        codigo: Number(item.codigo)
      }));
    }
  }

  public getTabData() {
    console.log("dt_contenedores", this.dt_contenedores)

    const contenedoresMapeados: D_getContenedoresOvRequest[] = this.dt_contenedores.map((item, i) => {
      return {
        ccot_tipo: this.oRow.ccot_tipo ?? 0,
        ccot_numero: this.oRow.ccot_numero ?? 0,
        dhbl_item: item.dhbl_item || item.key || i,
        cmbl_codigo: item.cmbl_codigo || null,
        pack_codigo: item.tipo_cntr?.value ? Number(item.tipo_cntr.value) : (typeof item.tipo_cntr === 'string' || item.tipo_cntr === undefined) ? Number(item.pack_codigo) : null,
        dhbl_pesobruto: item.dhbl_pesobruto ?? 0,
        dhbl_volumen: item.dhbl_volumen ?? 0,
        dhbl_cantbultos: item.dhbl_cantbultos ?? 0,
        dhbl_precinto: this.cleanValue(item.dhbl_precinto),
        cntr_numero: this.cleanValue(item.cntr_numero),
        dhbl_descproducto: this.cleanValue(item.dhbl_descproducto),
        dhbl_marcasnumeros: this.cleanValue(item.dhbl_marcasnumeros),
        dhbl_contractnro: this.cleanValue(item.dhbl_contractnro),
        dhbl_esimo: !!item.dhbl_esimo,
        dhbl_pp: !!item.dhbl_pp,
        tipo_tabimo: item.clase_imo?.value != null ? "IMO" : null,
        tipo_codimo: item.clase_imo?.value ?? null,
        tipo_tabcdt: item.clase_imo?.value != null ? "CDT" : null,
        tipo_codcdt: item.comodity?.value ?? null,
        tipo_tabpac: item.tipo_bulto?.value != null ? "PAC" : null,
        tipo_codpac: item.tipo_bulto?.value ?? null,
        dhbl_imoun: item.dhbl_imoun ?? null,
        audi_usrcrea: this.oRow.usuario ?? null,
        audi_usrmod: this.oRow.usuario ?? null,
        ESTADO_OBJ: item.ESTADO_OBJ ?? 'NA',
        dhbl_ratecharge: item.dhbl_ratecharge ?? 0,
      };
    });

    console.log("request contenedores:", contenedoresMapeados)

    return {
      formulario: this.group_emision.value,
      contenedores: contenedoresMapeados,
      form_master: this.group_master.value,
    };
  }

  public setTabData(data: any, listaContenedores: any[]) {
    this.group_emision.patchValue(data);
    this.dt_contenedores = [...listaContenedores];
  }

  //#region AUDITORÍA
  popUpAuditoriaContenedores: boolean = false;
  manejoPoupAuditoriaDatosEmision(opcion: string) {
    if (opcion === "A") {
      const request = <D_getAuditContenedoresRequest>{};
      request.ccot_tipo = this.oRow.ccot_tipo;
      request.ccot_numero = this.oRow.ccot_numero;
      this.opeRepository.auditoriaDetContenedores(request).subscribe(res => {
        if (res.datos.status == 200) {
          this.dt_auditoriaContenedores = res.datos.result;
          this.popUpAuditoriaContenedores = true;
        }
      }, err => { this.dt_auditoriaContenedores = []; this.popUpAuditoriaContenedores = true; })

    } else if (opcion === "C") {
      this.popUpAuditoriaContenedores = false;
      this.dt_auditoriaContenedores = [];
    }
  }

  exportarExcelAudiContenedores() {
    if (this.dt_auditoriaContenedores.length == 0) {
      this.util.MessageDialog({
        titulo: "ERROR",
        mensaje: "No hay campos para exportar",
        icono: "pi pi-exclamation-triangle",
        tipo: "warning"
      });
      return;
    }

    let nuevadata = [];
    this.dt_auditoriaContenedores.forEach(row => {
      // Destructuring basado en tu DTO de AuditoriaDetContenedores
      const {
        operacion, direccion_ip, nombre_maquina, nombre_aplicacion,
        usuario_sql, usuario_aplicacion, fecha_modificacion,
        codigo_ov, tipo_ov, codigo_mbl, cod_paquete,
        peso_bruto, volumen, cantidad_bultos, precinto,
        descripcion, marcas_numero, imo, cod_imo,
        es_imo, imo_un, nro_contract, parte_contenedor,
        nro_contenedor, item, comodity, cod_comodity,
        tipo_paquete, cod_tipo_paquete, usuario_crea,
        fec_crea, usuario_modifica, fec_modifica
      } = row;

      const newItem = {
        "Operacion": operacion,
        "Direccion IP": direccion_ip,
        "Nombre Maquina": nombre_maquina,
        "Nombre Aplicacion": nombre_aplicacion,
        "Usuario SQL": usuario_sql,
        "Usuario Aplicacion": usuario_aplicacion,
        "Fecha Modificacion": this.util.formatearfecha(fecha_modificacion, 'dd/mm/yyyy'),
        "Codigo OV": codigo_ov,
        "Tipo OV": tipo_ov,
        "Codigo MBL": codigo_mbl,
        "Cod Paquete": cod_paquete,
        "Peso Bruto": peso_bruto,
        "Volumen": volumen,
        "Cantidad Bultos": cantidad_bultos,
        "Precinto": precinto,
        "Descripcion": descripcion,
        "Marcas Numero": marcas_numero,
        "IMO": imo,
        "Cod IMO": cod_imo,
        "Es IMO": es_imo ? 'SI' : 'NO',
        "IMO UN": imo_un,
        "Nro Contract": nro_contract,
        "Parte Contenedor": parte_contenedor ? 'SI' : 'NO',
        "Nro Contenedor": nro_contenedor,
        "Item": item,
        "Comodity": comodity,
        "Cod Comodity": cod_comodity,
        "Tipo Paquete": tipo_paquete,
        "Cod Tipo Paquete": cod_tipo_paquete,
        "Usuario Crea": usuario_crea,
        "Fec Crea": this.util.formatearfecha(fec_crea, 'dd/mm/yyyy'),
        "Usuario Modifica": usuario_modifica,
        "Fec Modifica": this.util.formatearfecha(fec_modifica, 'dd/mm/yyyy')
      };

      nuevadata.push(newItem);
    });

    const fechaHora = this.util.formatearfecha(new Date(), 'fecha_hora');
    const nombreArchivo = `AUDITORÍA DET CONTENEDORES ${fechaHora}.xlsx`;

    const data = [{ data: nuevadata, cabeceras: [] }];
    this.util.ExportarExcel(data, nombreArchivo);
  }

  //#endregion

  private cleanValue(val: any) {
    return (val === null || val === undefined || (typeof val === 'string' && val.trim() === "")) ? null : val;
  }

  //#region DATOS DOCUMENTO MASTER

  private actualizarDescripcionEntidad(codigo_entc: number, descControlName: string, tipoEntidad: number, formGroup: FormGroup, aplicaVal: boolean = false) {
    const entidadId = codigo_entc;

    if (!entidadId) {
      formGroup.get(descControlName)?.setValue(null);
      return;
    }

    const currentDesc = formGroup.get(descControlName)?.value;
    if (aplicaVal && currentDesc && currentDesc.trim() !== "") {
      return;
    }

    const request = <BuscarPorEntidad_Request>{
      PvchTIPE_Codigo: tipoEntidad,
      PintENTC_Codigo: entidadId
    };

    this.ordenventaService.BuscarPorEntidad(request).subscribe({
      next: (res) => {
        if (res.datos.status === 200 && res.datos.result?.length > 0) {
          const ent = res.datos.result[0];

          const nuevaDesc = [
            `${ent.entc_NomCompleto || ''}`,
            `${ent.tipo_DescTDI || ''}: ${ent.entc_DocIden || ''}`,
            `${ent.dire_Direccion || ''}`,
            `${ent.dire_Ubigeo || ''}`,
            `Telf.: ${ent.entc_Telef1 || ''} Cel.: ${ent.entc_Telef2 || ''}`
          ].join('\n').trim();

          formGroup.get(descControlName)?.setValue(nuevaDesc);
        } else {
          formGroup.get(descControlName)?.setValue(null);
        }
      },
      error: (err) => {
        const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
        this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
      }
    });
  }

  onChangeShipperMbl(aplicaVal: boolean = false) {
    this.actualizarDescripcionEntidad(this.group_master.get('shipper')?.value, 'desc_shipper', FUNC_ENTIDAD.shipper, this.group_master, aplicaVal);
  }

  onChangeNotifyMbl(aplicaVal: boolean = false) {
    this.actualizarDescripcionEntidad(this.group_master.get('notify')?.value, 'desc_notify', FUNC_ENTIDAD.cliente, this.group_master, aplicaVal);
  }

  onChangeConsigneeMbl(aplicaVal: boolean = false) {
    this.actualizarDescripcionEntidad(this.group_master.get('consignee')?.value, 'desc_consignee', FUNC_ENTIDAD.cliente, this.group_master, aplicaVal);
  }

  onChangeShipper(codigo_entc: number, aplicaVal: boolean = false) {
    this.actualizarDescripcionEntidad(codigo_entc, 'shipper', FUNC_ENTIDAD.shipper, this.group_emision, aplicaVal);
  }

  onChangeNotify(codigo_entc: number, aplicaVal: boolean = false) {
    this.actualizarDescripcionEntidad(codigo_entc, 'notify', FUNC_ENTIDAD.cliente, this.group_emision, aplicaVal);
  }

  onChangeConsignee(codigo_entc: number, aplicaVal: boolean = false) {
    this.actualizarDescripcionEntidad(codigo_entc, 'consignee', FUNC_ENTIDAD.cliente, this.group_emision, aplicaVal);
  }

  onChangeMbl(mbl: string, aplicaVal: boolean = false) {

    const controls = ['shipper', 'desc_shipper', 'notify', 'desc_notify', 'consignee', 'desc_consignee'];

    if (!mbl?.trim()) {
      controls.forEach(c => this.group_master.get(c)?.setValue(null));
      return;
    }

    const { shipper, notify, consignee } = this.group_master.value;
    const tieneDatos = [shipper, notify, consignee].every(v => v?.toString().trim());

    if (aplicaVal && tieneDatos) {
      return;
    }

    const request = <getDatosByMblOperacionesRequest>{
      mbl: mbl,
      ccot_tipo: this.oRow.ccot_tipo,
      ccot_numero: this.oRow.ccot_numero
    };

    this.opeRepository.getDatosByMblOperaciones(request).subscribe({
      next: (res) => {
        if (res.datos.status === 200 && res.datos.result?.length > 0) {
          const datos = res.datos.result[0];
          this.group_master.get('shipper')?.setValue(datos.cod_shipper);
          this.group_master.get('desc_shipper')?.setValue(datos.desc_shipper);
          this.group_master.get('notify')?.setValue(datos.cod_notify);
          this.group_master.get('desc_notify')?.setValue(datos.desc_notify);
          this.group_master.get('consignee')?.setValue(datos.cod_consignee);
          this.group_master.get('desc_consignee')?.setValue(datos.desc_consignee);
          this.messageService.add({ key: 'Datos Master', severity: 'success', summary: 'Los datos del Master se actualizaron según el MBL ingresado.', detail: res.meta.mensaje, life: 4000 });
        }
      },
      error: (err) => {
        const mensaje = err?.error?.meta?.mensaje || (err?.error?.errors ? Object.values(err.error.errors).flat().join(' | ') : 'Error');
        console.warn(mensaje);
        // this.util.MessageDialog({ titulo: 'ERROR', mensaje: mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
      }
    });
  }

  //#endregion
}